<div class="container mt-5">
  <!-- Filter Section -->
  <form>
    <div class="row g-3 mb-3">
      <!-- Date Range -->
      <div class="col-md-4 mb-2">
        <label class="form-label">Từ ngày:</label>
        <dx-date-box
          [(value)]="filter.startDate"
          stylingMode="outlined"
          placeholder="dd/MM/yyyy"
          displayFormat="dd/MM/y"
          pickerType="calendar"
        >
        </dx-date-box>
      </div>
      <div class="col-md-4 mb-2">
        <label class="form-label">Đến ngày:</label>
        <dx-date-box
          [(value)]="filter.endDate"
          stylingMode="outlined"
          placeholder="dd/MM/yyyy"
          displayFormat="dd/MM/y"
          pickerType="calendar"
        >
        </dx-date-box>
      </div>

      <!-- Status Radio Buttons -->
      <div class="col-md-3 mb-2">
        <label class="form-label d-block">Trạng thái KQ:</label>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="status" id="notReady" [(ngModel)]="filter.status"
                 value="notReady">
          <label class="form-check-label" for="notReady">Chưa đủ KQ</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="status" id="ready" [(ngModel)]="filter.status"
                 value="ready">
          <label class="form-check-label" for="ready">Đủ KQ</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="status" id="all" [(ngModel)]="filter.status" value="all">
          <label class="form-check-label" for="all">Tất cả</label>
        </div>
      </div>

      <!-- Filter Button -->
      <div class="col-md-1 text-end mb-2">
        <label class="form-label d-block v-desktop">&nbsp;</label>
        <button style="width: 100%;" type="button" class="btn btn-primary btn-sm" (click)="doFilter()">
          <span class="fa fa-fw fa-search"></span>
          Lọc
        </button>
      </div>
    </div>
  </form>
  <dx-data-grid
    id="gridContainer"
    [dataSource]="datas"
    [showColumnLines]="true"
    [showRowLines]="true"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    [allowColumnResizing]="true"
    columnResizingMode="widget"
    [columnMinWidth]="50"
    [columnAutoWidth]="true"
    (onRowDblClick)="handleRowDblClick($event)"
  >
    <dxo-load-panel [enabled]="true"></dxo-load-panel>
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-export [enabled]="false" [allowExportSelectedData]="true"></dxo-export>
    <dxi-column caption="SID" dataField="sid"></dxi-column>
    <dxi-column caption="Tên khách hàng" dataField="fullName"></dxi-column>
    <dxi-column caption="Trạng thái" dataField="isResultText"></dxi-column>
    <dxi-column caption="Ngày" dataField="dateCreated" dataType="date"
                format="dd/MM/yyyy"></dxi-column>

    <dxi-column caption="" cellTemplate="cellDetailLink" [fixed]="true" [width]="175"
                fixedPosition="right"></dxi-column>
    <div *dxTemplate="let cellInfo of 'cellDetailLink'">
      <a title="" class="a-link" *ngIf="cellInfo.data.isValid"
         (click)="showDetail(cellInfo.data)">
        <span class="fa fa-fw fa-info-circle"></span>
        In KQ
      </a>
      <a title="" class="a-link" style="margin-left: 4px;"
         (click)="printReceipt(cellInfo.data)">
        <span class="fa fa-print fa-info-circle"></span>
        In phiếu thu
      </a>

    </div>
    <div *dxTemplate="let item of 'cellTemplate'">
    </div>
  </dx-data-grid>
</div>

<nz-modal [(nzVisible)]="isShowReport" nzTitle="Kết quả xét nghiệm" nzClosable="false" nzMaskClosable="false">
  <ng-template nzModalContent>
    <div class="row">
      <div class="col-md-6" *ngFor="let file of files">
        <a class="file-item" [href]="file.fileUrl" target="_blank">
          <span class="fa fa-fw fa-file"></span>
          <span>{{ file.fileName }}</span></a>
      </div>
    </div>
  </ng-template>
  <div *nzModalFooter>
    <button nz-button (click)="closeModal()">Đóng</button>
  </div>
</nz-modal>
